var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "list",
      attrs: {
        role: "listbox",
        tabindex: "0",
        "aria-labelledby": _vm.labelId,
        "aria-activedescendant": _vm.activeDescendant
      },
      on: {
        blur: function($event) {
          return _vm.reset(_vm.value)
        },
        keydown: function($event) {
          return _vm.handleKeydown($event)
        }
      }
    },
    [
      _c(
        "p",
        {
          staticClass: "news-filter-select__options-label",
          attrs: { id: _vm.labelId }
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + ":\n    ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.options, function(option) {
        return _c(
          "button",
          {
            key: option.value,
            ref: "option",
            refInFor: true,
            staticClass:
              "news-filter-select__option secondary-text text-uppercase d-block w-100 py-1 text-md-left font-family-alternative text-uppercase fs-h2",
            class: { selected: _vm.isSelected(option) },
            attrs: {
              id: _vm.optionId(option),
              type: "button",
              role: "option",
              tabindex: "-1",
              "aria-selected": _vm.isSelected(option) ? "true" : "false"
            },
            on: {
              click: function($event) {
                return _vm.$emit("select", option)
              }
            }
          },
          [_vm._v("\n        " + _vm._s(option.label) + "\n    ")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }